import React, { useState, useEffect } from "react";
import AnnouncementImg from "../../../Icons/AnnouncementBg.svg";
import { ReactComponent as BellIcon } from "../../../Icons/BellIcon.svg";
import {
  Typography,
  Box,
  Divider,
  Button,
  Stack,
  CardActionArea,
  CardActions,
  Grid,
  Card,
  CardContent,
  CardMedia,
  useMediaQuery,
} from "@mui/material";
import { ReactComponent as LeftArrowIcon } from "../../../Icons/leftArrow.svg";
import { ReactComponent as RightArrowIcon } from "../../../Icons/rightArrow.svg";
import { ReactComponent as ShareIcon } from "../../../Icons/ShareIcon.svg";
import { ReactComponent as FavouritesIcon } from "../../../Icons/favouritesIcon.svg";
import Bgimg from "../../../Icons/bgimg.svg";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import parse from "html-react-parser";
import { useSelector } from "react-redux";

export default function NewsList() {
  const language = useSelector((state) => state.language.language);
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate()
  const style = useSelector((state) => state.styles)
  console.log(style)


  const [announcementData, setAnnouncementData] = useState([]);



  const { id } = useParams();

  const [NewsData, setNewsData] = useState([]);



  const getAllNews = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}get-all-news`
      );
    
      setNewsData(response.data.data)
    } catch (error) {
      console.log(error);
    }
  };

  const getAllAnnouncement = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}get-all-announcements`
      );
      console.log(response?.data?.data);
      setAnnouncementData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllNews();
    getAllAnnouncement();
  }, []);

  useEffect(() => {
    getAllNews();
  }, [language]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const images = [
    {
      src: Bgimg,
    },
    {
      src: "https://images.pexels.com/photos/5137969/pexels-photo-5137969.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      src: "https://images.pexels.com/photos/7968277/pexels-photo-7968277.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
  ];

  const [NewsTags, setNewsTags] = useState([
    "tag",
    "tag",
    "tag_name",
    "tag",
    "tag_name",
    "tag",
    "tag_name",
    "tag_name",
    "tag",
    "tag_name",
    "tag_name",
    "tag",
  ]);

  const handleShare = (id) => {
    console.log("called")
    console.log(id)
    const url = `${window.location.origin}/news/${id}`;
  
    if (navigator.share) {
      navigator.share({
        title: "Check this out!",
        text: "Interesting News",
        url,
      }).catch((err) => {
        console.error("Sharing failed", err);
      });
    } else {
      navigator.clipboard.writeText(url).then(() => {
        // toast.success("Link copied to clipboard!");
      }).catch((err) => {
        console.error("Clipboard error", err);
      });
    }
  };

  const getPlainText = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  return (
    <Box>
      <Grid
        justifyContent="space-between"
        container
        sx={{ backgroundColor: "#EFF4FC" }}
      >
        <Grid xs={12} md={5.7} lg={6}>
          <Box
            component="img"
            src={AnnouncementImg}
            sx={{ width: "100%", height: "713px", objectFit: "none" }}
          ></Box>
        </Grid>
        <Grid
          display="flex"
          flexDirection="column"
          justifyContent="start"
          alignItems="center"
          backgroundColor="#EFF4FC"
          xs={12}
          md={5.7}
          lg={6}
          px={2}
        >
          <Stack py={6} direction="row" justifyContent="start">
            <Typography
              p={2}
              variant="h6_1"
              color="primary"
              border="1px solid #27BAC4"
              padding="10px 50px"
              borderRadius="50px"
              letterSpacing="1.1px"
            >
              ANNOUNCEMENTS
            </Typography>
          </Stack>
          <Stack
            sx={{
              backgroundColor: "white",
              // border: "0.5px solid #27BAC4",
              borderRadius: "20px",
              height: "60vh",
              width: { xs: "100%", sm: "86%", lg: "auto" },
              // background: "linear-gradient(to top, white, transparent)",
              zIndex: 5,
              boxShadow : '0px 0px 10px #00000010'
            }}
          >
            <Typography
              p={2}
              variant="h6_2"
              color="primary"
              textAlign="start"
              borderBottom="0.5px solid #27BAC4"
            >
              Announcements
            </Typography>
            <Stack
              rowGap="20px"
              p={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }}
              sx={{
                overflowY: "scroll",
                overflowX: "scroll",
                "&::-webkit-scrollbar": { display: "none" },
                

              }}
            >
              {announcementData?.map((itm, index) => (
                <>
                  <Stack
                    direction={{
                      xs: "column",
                      sm: "column",
                      md: "column",
                      lg: "column",
                      xl: "column",
                    }}
                    justifyContent="space-between"
                    height={{
                      xs: "auto",
                      sm: "auto",
                      md: "auto",
                      lg: "auto",
                      xl: "auto",
                    }}
                    
                    sx={{p : {xs : 0, sm : 2, lg : 0}}}
                  >
                    <Stack direction="row" sx={{}} columnGap={{xs : '10px', sm : '40px', lg : '10px'}} alignItems="center">
                      <Box
                        sx={{
                          width: {xs : '45px', sm : '70px', lg : '45px'},
                          height: {xs : '45px', sm : '70px', lg : '45px'},
                          borderRadius: "100px",
                          backgroundColor: "button",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <BellIcon width='100%' height='45%'/>
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="start"
                        sx={{ height : 'auto', width : '80%'}}
                      >
                        <Typography sx={{...style.subheading}} color="text_blue">
                          {itm?.title?.[language]}
                        </Typography>
                        <Typography sx={{...style.subheadingDescription}} color="text_blue">
                          {itm?.subtitle?.[language]}
                        </Typography>
                      </Box>
                    </Stack>
                    <Stack
                      alignItems={{ xs: "start", lg: "start" }}
                      sx={{ px: { xs: "54px", sm : '110px',lg: "54px" }, pt : '4px' }}
                    >
                      <Typography sx={{...style.subTimeDate}} color="#606060">
                        {itm?.time}
                      </Typography>
                      <Typography sx={{...style.subTimeDate}} color="#606060">
                        {itm?.date}
                      </Typography>
                    </Stack>
                  </Stack>
                  {/* </>)} */}
                </>
              ))}
            </Stack>
          </Stack>
          {/* <Stack
            sx={{
              position: "relative",
              backgroundColor: "white",
              border: "0.5px solid #27BAC4",
              borderRadius: "20px",
              width: { xs: "100%", sm: "86%", lg: "auto" },
              marginBottom: "4rem",
              zIndex: 2,
              overflow: "hidden",
            }}
          >
            <Typography
              p={2}
              variant="h6_2"
              color="primary"
              textAlign="start"
              borderBottom="0.5px solid #27BAC4"
            >
              Announcements
            </Typography>
            <Stack
              rowGap="20px"
              p={{ sm: 3, xs: 1 }}
              sx={{
                overflowY: "scroll",
                "&::-webkit-scrollbar": { display: "none" },
                position: "relative",
                height: "400px", // Adjust height as needed
              }}
            >
              {announcementData?.map((item, index) => (
                <Stack
                  direction={{
                    xs: "column",
                    sm: "column",
                    md: "column",
                    lg: "row",
                    xl: "row",
                  }}
                  columnGap={{ sm: 7, xs: 3 }}
                  justifyContent="space-between"
                  height={{
                    xs: "70px",
                    sm: "70px",
                    md: "70px",
                    lg: "60px",
                    xl: "53px",
                  }}
                >
                  <Stack direction="row" columnGap="10px" alignItems="center">
                    <Box
                      sx={{
                        width: "45px",
                        height: "45px",
                        borderRadius: "100px",
                        backgroundColor: "button",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BellIcon />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      textAlign="start"
                    >
                      <Typography variant="h6_1" color="text_blue">
                        {item?.title?.[language]}
                      </Typography>
                      <Typography variant="h9_2" color="text_blue">
                        {item?.subtitle?.[language]}
                      </Typography>
                    </Box>
                  </Stack>
                  <Stack
                    alignItems={{ xs: "start", lg: "end" }}
                    sx={{ px: { xs: "54px", lg: "0px" } }}
                    justifyContent="center"
                  >
                    <Typography variant="h9_2" color="#606060">
                      {item?.time}
                    </Typography>
                    <Typography variant="h9_2" color="#606060">
                      {item?.date}
                    </Typography>
                  </Stack>
                </Stack>
              ))}
            </Stack>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "1000px", // Adjust height as needed
                background: "linear-gradient(to top, white, transparent)",
                zIndex: 3,
              }}
            />
          </Stack> */}
        </Grid>
      </Grid>

      <Box mt={7} width="100%">
        <Stack px={5} direction="row" justifyContent="center">
          <Typography
            p={2}
            variant="h6_1"
            color="primary"
            border="1px solid #27BAC4"
            padding="10px 50px"
            borderRadius="50px"
            letterSpacing="1.1px"
          >
            NEWS
          </Typography>
        </Stack>
      </Box>
      <Grid
        container
        gap="30px"
        mt={5}
        pb={10}
        px={2}
        justifyContent="center"
        marginBottom="0px"
      >
        <Grid md={10} container gap="30px">
          {NewsData?.map((itm, index) => (
            <>
              <Card
                
                sx={{
                  width: "100%",
                  p: 1,
                  pt: { sm: 1, xs: 2 },
                  border: "0px solid #cbcbcc",
                  boxShadow: "0px 0px 30px 20px #f4f4f4",
                  height : 'auto',
                  borderRadius: "20px",
                  textAlign: "start",
                  display: "flex",
                  flexDirection: { sm: "row", xs: "column-reverse" },
                  justifyContent: "space-between",
                  alignItems: isMobile ? "start" : "center",
                }}
              >
                <Box sx={{ width : {xs : '100%', sm : '70%'}}}>
                  <>
                    <CardContent>
                      <Stack sx={{":hover" : {cursor : 'pointer'}}} onClick={() => navigate(`/news/${itm?._id}`)} direction="column" alignItems="start" gap="10px">
                        {/* <Typography
                          variant="h9_4"
                          color="#007ECA"
                          sx={{
                            width: "42px",
                            height: "24px",
                            border: ".5px solid #007ECA",
                            padding: "0 10px 26px 10px",
                            borderRadius: "80px",
                          }}
                        >
                          tag
                        </Typography> */}
                        <Typography
                          gutterBottom
                          variant="h7_1"
                          component="div"
                          color="#007ECA"
                        >
                          {itm?.title?.[language]}
                        </Typography>
                        {/* <Typography variant="h9_4">
                          {Boolean(itm?.description?.[language])
                            ? parse(itm?.description?.[language])
                            : "-"}
                        </Typography> */}
                          <Typography variant="h9_4">
                            {Boolean(itm?.description?.[language]) ? (
                              (() => {
                                const plain = getPlainText(itm.description[language]);
                                const truncated = plain.length > 100 ? plain.slice(0, 150) + "..." : plain;
                                return truncated;
                              })()
                            ) : (
                              "-"
                            )}
                          </Typography>
                      </Stack>
                      <Stack mt={4} direction="row" gap="20px">
                        {/* <Box
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "100px",
                            backgroundColor: "#27BAC4",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <FavouritesIcon fill="#FFFFFF" />
                        </Box> */}
                        <Box
                          onClick={() => handleShare(itm?._id)}
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "100px",
                            backgroundColor: "#27BAC4",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex:10000000,
                            ":hover" : {
                              cursor :'pointer'
                            }
                          }}
                        >
                          <ShareIcon fill="#FFFFFF" />
                        </Box>
                      </Stack>
                    </CardContent>
                  </>
                </Box>
                <Box>
                  <CardMedia
                    sx={{
                      borderRadius: "20px",
                      height: isMobile ? "100%" : "240px",
                      width: isMobile ? "100%" : "240px",
                      px: 1,
                    }}
                    component="img"
                    image={process.env.REACT_APP_FILE_PATH + itm?.img}
                    
                  />
                </Box>
              </Card>
            </>
          ))}
        </Grid>
        {/* <Grid md={3} p={1} px={2} borderLeft=".5px solid #737373">
          <Typography variant="h6_1">Tags</Typography>
          <Box mt={2} gap="20px" sx={{ display: "flex", flexWrap: "wrap" }}>
            {NewsTags?.map((item, index) => (
              <Typography
                variant="h9_4"
                color="#007ECA"
                sx={{
                  width: "fit-content",
                  height: "24px",
                  border: ".5px solid #007ECA",
                  padding: "0 10px 26px 10px",
                  borderRadius: "80px",
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}
